import { createFileRoute } from '@tanstack/react-router';
import { LoansCard } from '@/components/finance/loans';

// Loans (candidate/bank loans, FEC Schedule C) are working data that feed report
// schedules, so the card mounts here as a first-class Finance tab instead of under
// Campaign Settings. The card is self-contained (its own query hooks); the route
// only frames it.
export const Route = createFileRoute('/admin/finance/loans/')({
  component: FinanceLoansPage,
});

function FinanceLoansPage() {
  return (
    <div className="p-6">
      <div className="max-w-3xl">
        <LoansCard />
      </div>
    </div>
  );
}
